import type { TPatternValidatorParams } from '@ballerine/common';

import type { TValidator } from '../../types';
import { formatErrorMessage } from '../../utils/format-error-message';

export const patternValueValidator: TValidator<string, TPatternValidatorParams> = (
  value,
  params,
) => {
  const { message = `Value must match {pattern}.` } = params;

  if (typeof value !== 'string') return true;

  if (!new RegExp(params.value.pattern, params.value.flags).test(value)) {
    throw new Error(formatErrorMessage(message, 'pattern', params.value.pattern));
  }
};
